import React from 'react';
import { Feed } from 'semantic-ui-react';
import moment from 'moment';

import HistoryItem from './HistoryItem';

const ClaimHistory = ({ history }) => {
  return (
    <Feed>
      {history &&
        history.map((entry, index) => {
          const {
            author,
            createdAt,
            claimHistoryEntryType,
            content,
            resourceId,
            details
          } = entry;
          return (
            <HistoryItem
              key={index}
              index={index}
              indicator={author ? 'manual' : 'auto'}
              assignee={author ? `${author.name} ${author.surname}` : ''}
              date={moment(createdAt).format('DD/MM/YYYY h:mm')}
              claimHistoryEntryType={claimHistoryEntryType}
              content={content}
              resourceId={resourceId}
              details={details}
            />
          );
        })}
    </Feed>
  );
};

export default ClaimHistory;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/index.js